import { forwardRef } from 'react'

import { OpenSearchForm } from '~/features/common'
import { twMerge } from '~/lib/utils'

type SearchConditionProps = {
  searchConditionText: string
  isNarrow?: boolean
  onClick: () => void
}

export const SearchCondition = forwardRef<HTMLDivElement, SearchConditionProps>(
  ({ searchConditionText, isNarrow = false, onClick }, ref) => {
    return (
      <div
        className={twMerge(
          'flex flex-row items-center justify-between gap-2 bg-grayBg px-4 py-2',
          isNarrow && 'px-0',
        )}
        ref={ref}
      >
        <div className="min-w-0">
          <p className="text-body-s">現在の検索条件：</p>
          <p className="truncate text-body-s">{searchConditionText}</p>
        </div>
        <div className="shrink-0">
          <OpenSearchForm className="w-[130px]" onClick={onClick} size="medium">
            条件変更
          </OpenSearchForm>
        </div>
      </div>
    )
  },
)

SearchCondition.displayName = 'SearchCondition'
